/* eslint-disable */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IBenefit, IBenefitsReview } from 'src/interfaces';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';
import CurrentBenefitsCard from '../current-benefits-card';
import {
  CurrentBenefitsContainer,
  CurrentBenefitsTitle,
  BenefitsTitleContainer,
  BiWeeklyText,
  CurrentBenefitsFooter,
  CurrentBenefitsFooterText,
  CurrentBenefitsGridContainer,
  Container,
  ColumnHeader,
} from './styles';

import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components';
import './styles.css';
import { BenefitsSummaryHistory } from '../benefits-summary-history';

const CurrentBenefits: React.FC<{
  active: string;
}> = ({ active }) => {
  const { t } = useTranslation();
  const { data } = useTypedSelector(state => state.benefits);

  // eslint-disable-next-line no-unused-vars
  const [selectedBenefit, setSelectedBenefit] = useState('');
  const { personalInfo } = useTypedSelector(state => state.personalInfo.data);

  const { isLoading, data: lastBenefitsData } = useQuery({
    queryKey: ['benefits/available-benefits'],
    queryFn: () => BenefitsService.getBenefits(),
    enabled: true,
  });

  const { getBenefits } = useActions();

  useEffect(() => {
    getBenefits();
  }, []);

  return (
    <CurrentBenefitsContainer>
      <BenefitsTitleContainer>
        <CurrentBenefitsTitle>{active === 'deductions' ? '' : 'Current Deductions'}</CurrentBenefitsTitle>

        <BiWeeklyText>(Semi-Monthly)</BiWeeklyText>
      </BenefitsTitleContainer>

      <>
        {active === 'deductions' ? (
          <BenefitsSummaryHistory />
        ) : (
          <CurrentBenefitsGridContainer>
            {data?.benefits?.map((benefit: IBenefit, index: number) => (
              <CurrentBenefitsCard
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                id={benefit.benefitId}
                title={benefit.type}
                imgURL={benefit.imgURL}
                fee={benefit.employeeCost}
                freePlan={benefit.costCalculationMethod === 'Free'}
                provideBeneficiaries={benefit.necessaryToProvideBeneficiariesInformation}
                benefitName={benefit.benefitName}
                basis={benefit.basis}
                setSelectedBenefit={setSelectedBenefit}
              />
            ))}
          </CurrentBenefitsGridContainer>
        )}
      </>

      <CurrentBenefitsFooter>
        <CurrentBenefitsFooterText>
          {active !== 'deductions' ? (
            <>
              {t('benefits.content.activeBenefits.totalDeductions')} {monetaryUSDFormat(data.totalDeduction)}
            </>
          ) : (
            ''
          )}
        </CurrentBenefitsFooterText>
      </CurrentBenefitsFooter>
    </CurrentBenefitsContainer>
  );
};

export default CurrentBenefits;
